import { openDB } from 'idb';
import {useAppStore} from '../stores/app';
import { apiClient } from './client';

const DB_NAME = 'api-log-client';
const OUTBOX = 'outbox';

import { ref } from 'vue';
import { useUiStore } from '../stores/ui';

const dbp = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(OUTBOX)) {
      db.createObjectStore(OUTBOX, { keyPath: 'id', autoIncrement: true });
    }
  }
});

export async function addToOutbox(entry) {
  const db = await dbp; await db.add(OUTBOX, { ...entry, createdAt: Date.now() });
  const app = useAppStore();
  app.queued_items++;
  //const ui = useUiStore();
  //ui.triggerRefreshStats();

}

export async function getAllOutbox() {
  const db = await dbp; return db.getAll(OUTBOX);
}

export async function clearOutbox(ids) {
  const db = await dbp; const tx = db.transaction(OUTBOX, 'readwrite');
  for (const id of ids) await tx.store.delete(id);
  await tx.done;
  const app = useAppStore();
  app.queued_items = 0;
  
  const ui = useUiStore();
  ui.triggerRefreshStats();
}

export async function getOutboxCount() {
  const db = await dbp; return (await db.getAllKeys(OUTBOX)).length;
}

export async function drainOutbox() {
  if (!navigator.onLine) return;
  const items = await getAllOutbox();
  if (!items.length) return;
  const okIds = [];
  
  for (const item of items) {
    try {

      const res = await apiClient.post(
        item.endpoint, 
        item.body ? JSON.stringify(item.body) : undefined,
        item.headers || { 'Content-Type': 'application/json' }
      )

      // const ret = await fetch(item.endpoint, {
      //   method: item.method || 'POST',
      //   headers: item.headers || { 'Content-Type': 'application/json' },
      //   body: item.body ? JSON.stringify(item.body) : undefined
      // });
      // if (res.ok) okIds.push(item.id);
      okIds.push(item.id);
    } catch (e) { /* keep it for next retry */ }
  }
  if (okIds.length) await clearOutbox(okIds);
}